// Import all icon libraries that might be used
import * as FaIcons from 'react-icons/fa';
import * as FiIcons from 'react-icons/fi';
import * as AiIcons from 'react-icons/ai';
import * as BiIcons from 'react-icons/bi';
import * as BsIcons from 'react-icons/bs';
import * as CgIcons from 'react-icons/cg';
import * as DiIcons from 'react-icons/di';
import * as FcIcons from 'react-icons/fc';
import * as GoIcons from 'react-icons/go';
import * as GrIcons from 'react-icons/gr';
import * as HiIcons from 'react-icons/hi';
import * as Hi2Icons from 'react-icons/hi2';
import * as ImIcons from 'react-icons/im';
import * as IoIcons from 'react-icons/io';
import * as Io5Icons from 'react-icons/io5';
import * as LuIcons from 'react-icons/lu';
import * as MdIcons from 'react-icons/md';
import * as RiIcons from 'react-icons/ri';
import * as SiIcons from 'react-icons/si';
import * as TbIcons from 'react-icons/tb';
import * as TiIcons from 'react-icons/ti';
import * as VscIcons from 'react-icons/vsc';
import * as WiIcons from 'react-icons/wi';
import * as CiIcons from 'react-icons/ci';

// Combine all icon libraries into one object
const allIcons = {
    ...FaIcons,
    ...FiIcons,
    ...AiIcons,
    ...BiIcons,
    ...BsIcons,
    ...CgIcons,
    ...DiIcons,
    ...FcIcons,
    ...GoIcons,
    ...GrIcons,
    ...HiIcons,
    ...Hi2Icons,
    ...ImIcons,
    ...IoIcons,
    ...Io5Icons,
    ...LuIcons,
    ...MdIcons,
    ...RiIcons,
    ...SiIcons,
    ...TbIcons,
    ...TiIcons,
    ...VscIcons,
    ...WiIcons,
    ...CiIcons
};

const DynamicIconRenderer = ({
    iconName,
    size = 16,
    color,
    className,
    style,
    fallback = null,
    ...props
}) => {
    // If no icon name provided, return fallback or null
    if (!iconName) {
        return fallback;
    }

    // Get the icon component from the combined icons object
    const IconComponent = allIcons[iconName];

    // If icon not found, return fallback or null
    if (!IconComponent) {
        console.warn(`Icon "${iconName}" not found in react-icons libraries`);
        return fallback;
    }

    // Render the icon with provided props
    return (
        <IconComponent
            size={size}
            color={color}
            className={className}
            style={style}
            {...props}
        />
    );
};

export default DynamicIconRenderer;
